﻿package com.milta.core.localization.translations.pl

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Mój profil",
    sectionPersonal = "Dane osobowe",
    labelFirstName = "Imię",
    labelLastName = "Nazwisko",
    labelRole = "Rola",
    sectionLanguage = "Język",
    labelLanguage = "Język aplikacji",
    changeLanguageButton = "Zmień język",
    languageDialogTitle = "Wybierz swój język",
    languageDialogConfirm = "Potwierdź",
    languageDialogCancel = "Anuluj",
    sectionPassword = "Bezpieczeństwo",
    labelCurrentPassword = "Aktualne hasło",
    labelNewPassword = "Nowe hasło",
    changePasswordButton = "Zmień hasło",
    successLanguageUpdated = "Język został pomyślnie zaktualizowany",
    successPasswordChanged = "Hasło zostało pomyślnie zmienione",
    errorProfileNotFound = "Profil nie został znaleziony",
    errorCurrentPasswordRequired = "Wprowadź aktualne hasło",
    errorCurrentPasswordTooLong = "Aktualne hasło nie może przekraczać 128 znaków",
    errorNewPasswordRequired = "Wprowadź nowe hasło",
    errorNewPasswordTooShort = "Nowe hasło musi mieć co najmniej 8 znaków",
    errorNewPasswordTooLong = "Nowe hasło nie może przekraczać 128 znaków",
    errorLanguageRequired = "Wybierz język",
    errorForbidden = "Nie masz uprawnień do wykonania tej czynności",
    errorValidation = "Podane dane są nieprawidłowe",
    errorGeneric = "Wystąpił błąd. Spróbuj ponownie.",
    signOut = "Wyloguj się",
    deleteAccount = "Usuń konto",
    menuLanguage = "Język interfejsu",
    menuPassword = "Zmień hasło",
    menuSubscription = "Moja subskrypcja",
    menuPrivacy = "Prywatność i RODO",
    menuTerms = "Warunki korzystania",
    legalUpdatedAtPrefix = "Ostatnia aktualizacja",
    linkedCodeLabel = "Unikalny kod połączenia",
    linkedCodeLoadError = "Nie udało się załadować kodu połączenia. Spróbuj ponownie później.",
    copyCode = "Kopiuj",
    codeCopied = "Skopiowano!",
    modeOrganisation = "Firma",
    modeDriver = "Kierowca",
    roleDriver = "Kierowca",
    roleOrganisation = "Firma",
    modeSwitchTitle = "Zmień tryb",
    modeSwitchHint = "Przełączaj się między trybem Firmy a trybem Kierowcy w dowolnym momencie",
    switchToEnterprise = "Tryb Firmy",
    switchToDriver = "Tryb Kierowcy",
    menuPhone = "Numer telefonu",
    phoneOtpStepTitle = "Kod weryfikacyjny wysłany SMS-em",
    successPhoneUpdated = "Numer telefonu został zaktualizowany",
    deleteAccountDialogTitle = "Usunąć konto?",
    deleteAccountDialogMessage = "Ta czynność jest nieodwracalna. Twoje dane osobowe zostaną usunięte. Kod weryfikacyjny zostanie wysłany SMS-em w celu potwierdzenia.",
    deleteAccountDialogConfirm = "Kontynuuj",
    deleteAccountOtpStepTitle = "Kod weryfikacyjny wysłany SMS-em",
    deleteAccountConfirmButton = "Usuń trwale",
    errorLastEnterpriseOwner = "Jesteś jedynym menedżerem swojej firmy. Dodaj inne konto Firmy przed usunięciem swojego.",
    logoutPendingWarningTitle = "Niewysłane dostawy",
    logoutPendingWarningMessageSuffix = "dostawa/y w oczekiwaniu zostaną utracone, jeśli wylogujesz się teraz.",
    logoutPendingWarningConfirm = "Wyloguj się mimo to",
    logoutPendingWarningCancel = "Anuluj",
    modeSwitchActiveRouteWarningTitle = "Trasa w toku",
    modeSwitchActiveRouteWarningMessage = "Trasa jest obecnie w trakcie realizacji. Zmiana trybu spowoduje utratę jej śledzenia. Kontynuować?",
    modeSwitchActiveRouteWarningConfirm = "Zmień mimo to",
    modeSwitchActiveRouteWarningCancel = "Anuluj",
)

